module.exports = __webpack_public_path__ + "static/img/Boss_31084.f94f2e02.png";